export class ChangePasswordDTO {
    oldPassword: string;
    password: string;
    passwordReply: string;
}